import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const PrintIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M8,21.19a1.89,1.89,0,0,1-1.41-.59A1.93,1.93,0,0,1,6,19.19v-2H4a1.89,1.89,0,0,1-1.41-.59A1.93,1.93,0,0,1,2,15.19v-4a2.87,2.87,0,0,1,.88-2.14A2.92,2.92,0,0,1,5,8.19H19a2.94,2.94,0,0,1,3,3v4a1.93,1.93,0,0,1-.59,1.41,1.89,1.89,0,0,1-1.41.59H18v2a1.93,1.93,0,0,1-.59,1.41,1.89,1.89,0,0,1-1.41.59Zm-4-6H6a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2h2v-4a1,1,0,0,0-1-1H5a1,1,0,0,0-1,1Zm12-7v-3H8v3H6v-3a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2v3Zm2,4.5a.94.94,0,0,0,.71-.29,1,1,0,1,0-1.42,0A.94.94,0,0,0,18,12.69Zm-2,6.5v-4H8v4Z" />
    </SvgIcon>
  )
}
export default PrintIcon
